export default "__VITE_ASSET__BbNa4nlw__"